export default "__VITE_ASSET__DY6rFxS8__"